// extracted by mini-css-extract-plugin
module.exports = {"renderer":"renderer_renderer__H2Wix"};